//
// table.js
//

import { Dropdown } from 'bootstrap';

const linkRows = document.querySelectorAll('tr[role="link"]');
const offcanvasTriggerRows = document.querySelectorAll('tr[data-bs-toggle="offcanvas"]');
const offcanvasElements = document.querySelectorAll('.offcanvas');
const interactiveSelectors = 'a, button, input';

let shouldPreventOffcanvas = false;

linkRows.forEach((row) => {
  row.addEventListener(
    'click',
    (event) => {
      if (event.target.closest(interactiveSelectors)) {
        event.stopPropagation();
        if (event.target.matches('.dropdown-item')) {
          const dropdownInstance = Dropdown.getInstance(event.target.closest('.dropdown').querySelector('[data-bs-toggle="dropdown"]'));
          dropdownInstance.hide();
        }
      }
    },
    true
  );
});

offcanvasTriggerRows.forEach((row) => {
  ['mouseup', 'keyup'].forEach((e) => {
    row.addEventListener(
      e,
      (event) => {
        if (event.target.closest(interactiveSelectors)) {
          shouldPreventOffcanvas = true;
        }
      },
      true
    );
  });
});

offcanvasElements.forEach((offcanvas) => {
  offcanvas.addEventListener('show.bs.offcanvas', (event) => {
    if (shouldPreventOffcanvas) {
      event.preventDefault();
      shouldPreventOffcanvas = false;
    }
  });
});
